import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//手机号登录
export const login = data => http.post('/common/LoginByCode', data);

export const WechatLogin = data => http.post('/common/WechatLogin', data);


//绑定邀请码
export const setInvite = data => http.post('/mini/Invite', data);

//关于我们
export const about = data => http.get('/mini/Config/ABOUT_US');

//常见问题
export const getQuestion = data => http.get('/mini/Problem', data);

//获取会员详情
export const getMember = data => http.get('/mini/Member/'+ data.uuid);

//获取会员列表
export const getMemberList = data => http.get('/mini/Member');

//核心技术
export const getArt = data => http.get('/mini/Art',data);

//核心技术详情
export const getArtDeatil = data => http.get('/mini/Art/'+data.uuid);

//服务据点
export const getService = data => http.get('/mini/ServiceLocation');

//会员开通记录
export const getMemberOrderLog = data => http.get('/mini/MemberOrderLog');

//购买/续费会员
export const buyMemberOrder = data => http.post('/mini/MemberOrder',data);

//配置详情
export const getConfigDetail = data => http.get('/mini/Config/'+data.key);

//积分规则
export const getConfigList = data => http.get('/mini/Config');

//积分规则
export const toFeedback = data => http.post('/mini/Feedback',data);

//获取小程序二维码
export const getFetchQRCode = data => http.get('/common/FetchQRCode',data);

export const WechatLoginBindPhone = data => http.post('/common/WechatLoginBindPhone',data);
